import React from 'react';
import { motion } from 'framer-motion';
interface BibleRevealProps {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
}
export function BibleReveal({
  children,
  delay = 0,
  y = 28,
  className = ''
}: BibleRevealProps) {
  return <motion.div initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} className={className} data-id="element-39" data-mp="3aumrsqzl7kxo">
      {children}
    </motion.div>;
}